/**
 * DemoRibbon — fixed corner ribbon shown on any /demo/* route.
 *
 * Signals to donors and stakeholders that the current view is a prototype
 * and any donation flows are simulated. Deliberately restrained: small type,
 * ink background, one tangerine dot to match the site's palette dot vocabulary.
 * Sits bottom-left so it never covers the primary Donate CTA (bottom-right on
 * mobile) or the cookie banner if one is later added.
 */

import { useLocation, Link } from "react-router-dom";

export const DemoRibbon = () => {
  const { pathname } = useLocation();
  const onDemo = pathname === "/demo" || pathname.startsWith("/demo/");
  if (!onDemo) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="demo-ribbon"
      className="pointer-events-none fixed bottom-4 left-4 z-[100] select-none"
    >
      <div className="pointer-events-auto flex items-center gap-2 rounded-full bg-ink px-4 py-2 text-[13px] font-medium tracking-wide text-sand shadow-lg ring-1 ring-ink/10">
        <span aria-hidden className="h-2 w-2 rounded-full bg-tangerine" />
        <span>Prototype — simulated flows</span>
        <Link
          to="/"
          data-testid="demo-ribbon-exit"
          className="ml-2 rounded-full bg-sand/10 px-2.5 py-0.5 text-[13px] uppercase tracking-[0.18em] text-sand/85 transition-colors hover:bg-sand/20 hover:text-sand"
        >
          Exit
        </Link>
      </div>
    </div>
  );
};
